import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'

export default function Main() {
  const [seo, setSeo] = useState([])

  useEffect(() => {
    getAllseo();
  }, []);

  const getAllseo = async () => {
    const data = new FormData();
    data.append('name', "nme");

    axios({
      method: 'post',
      url: '/api/seo/list.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        setSeo(s.data)
        console.log(s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            {/* 2 */}
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  {/* Modern Header Added Here */}
                  <div className="card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div className="avatar avatar-sm me-3 bg-white text-dark rounded-circle d-flex align-items-center justify-content-center">
                          <i className="link-icon" data-feather="list" style={{ width: '18px', height: '18px' }}></i>
                        </div>
                        <div>
                          <h4 className="mb-1">View SEO List</h4>
                          <span className="opacity-75">Manage and review all your SEO optimized pages</span>
                        </div>
                        <span className="badge bg-light text-dark ms-auto py-2 px-3">
                          <i className="link-icon me-1" data-feather="database" style={{ width: '14px', height: '14px' }}></i>
                          {seo.length} Entries
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table id="dataTableExample" className="table">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>URL</th>
                              <th>Title</th>
                              <th>H1</th>
                              <th>Preview</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              seo.map((v) => (
                                <tr key={v.id}>
                                  <td>{v.id}</td>
                                  <td className="text-truncate" style={{ maxWidth: '200px' }}>{v.url}</td>
                                  <td className="text-truncate" style={{ maxWidth: '250px' }} title={v.t}>{v.t}</td>
                                  <td className="text-truncate" style={{ maxWidth: '200px' }} title={v.h1}>{v.h1}</td>
                                  <td>
                                    <div className="text-truncate" style={{ maxWidth: '300px' }} title={v.code}>
                                      {v.code.split(' ').slice(0, 50).join(' ') + (v.code.split(' ').length > 50 ? '...' : '')}
                                    </div>
                                  </td>
                                 <td>
  <a href={"updateseo?id=" + v.id}>
    <button className="btn btn-primary btn-sm">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
      </svg>
      Edit
    </button>
  </a>
</td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}